import { usePrevetAPI, CreateVesselSensitivityInputObject } from "./usePrevetAPI"
import { useState } from "react"
import axios from "axios"
import { toast } from "react-toastify"

export function useAddVesselSensitivityInput() {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { addVesselSensitivityInput } = usePrevetAPI()
  const createVesselSensitivityInput = async (
    vsi: CreateVesselSensitivityInputObject
  ) => {
    try {
      setIsLoading(true)
      await addVesselSensitivityInput(vsi)
    } catch (err: unknown) {
      const message = "Unable to add vessel sensitivity input"
      console.error(message, err)
      if (axios.isAxiosError(err)) {
        toast.warn(message, {
          position: "bottom-right",
          autoClose: 8000,
        })
      }
    } finally {
      setIsLoading(false)
    }
  }
  return { createVesselSensitivityInput, isLoading }
}
